import { NodeGroup } from './node-group';

export class RootNode extends NodeGroup {
    protected svgCircle: any;
    public xOffset: number = 0;
    public yOffset: number = 0;

    constructor() {
        super();
    }

    public isRoot() {
        return true;
    }

    public calculateLayout(size: number) {
        // first recursively calculate all radii
        this.setRadii();
        // then let d3 loose
        this.calculateLayoutRecursive();
        // then normalize
        this.normalizeLayout();
        // finally, scale to the pixels we have
        this.calculatePixelPositions(size);
    }

    public normalizeLayout() {
        this.r = 1;
        this.x = 0;
        this.y = 0;
        super.normalizeLayoutRecursive();
    }

    public calculatePixelPositions(size: number) {
        this.pixelR = (size * this.r) / 2;
        this.pixelX = this.xOffset + size * this.x + this.pixelR;
        this.pixelY = this.yOffset + size * this.y + this.pixelR;
        this.positionUpdated.post();
        this.children.forEach(child => {
            child.calculatePixelPositionsRecursive();
        });
    }
}
